import { render, staticRenderFns } from "./BottleSizeDropdown.vue?vue&type=template&id=ad1994e2&scoped=true&"
import script from "./BottleSizeDropdown.vue?vue&type=script&lang=js&"
export * from "./BottleSizeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1994e2",
  null
  
)

export default component.exports